import { ReactNode } from "react";
import cs from "classnames";
import styles from "./index.module.scss";
import ReadOnly from "../../ReadOnly";
import { Heading } from "../../Type";

const FormContent = ({
  background = true,
  title,
  children,
  readOnly = false,
}: {
  background?: boolean;
  title: string;
  children: ReactNode | ReactNode[];
  readOnly?: boolean;
}) => {
  return (
    <div className={cs(styles.container, background && styles.background)}>
      <div className={styles.header}>
        <Heading size="h4">{title}</Heading>
        <span className={styles.rightGroup}>
          {readOnly && <ReadOnly className={styles.readOnlyLabel} />}
        </span>
      </div>
      <div className={styles.children}>{children}</div>
    </div>
  );
};

export default FormContent;
